import { render, staticRenderFns } from "./select-service-project.vue?vue&type=template&id=20596519&scoped=true&"
import script from "./select-service-project.vue?vue&type=script&lang=js&"
export * from "./select-service-project.vue?vue&type=script&lang=js&"
import style0 from "./select-service-project.vue?vue&type=style&index=0&id=20596519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20596519",
  null
  
)

export default component.exports